import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { MarkdownOpeningParagraphProps } from './markdown-opening-paragraph.types';
import {
  GridWrapper,
  StyledMarkdownContainer,
} from './markdown-opening-paragraph.styles';

const MarkdownOpeningParagraph = ({
  markdownText,
}: MarkdownOpeningParagraphProps) => {
  const [sanitizedHtml, setSanitizedHtml] = useState<string | null>(null);

  useEffect(() => {
    if (!markdownText) return;

    const renderMarkdown = async () => {
      const convertedMarkdown = markdownText.replace(/^# /gm, '## ');
      const rawHtml = await marked(convertedMarkdown);
      const clean = DOMPurify.sanitize(rawHtml);
      setSanitizedHtml(clean);
    };

    renderMarkdown();
  }, [markdownText]);

  if (!sanitizedHtml) return null;

  return (
    <GridWrapper>
      <StyledMarkdownContainer
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    </GridWrapper>
  );
};

export default MarkdownOpeningParagraph;
